import reduce from 'lodash/fp/reduce'


const fields = {
    CONFIRM_PASSWORD: 'confirmPassword',
    PASSWORD: 'password'
}

export const initialValues = reduce((acc, field) => ({
    confirmPassword: '',
    password: ''
}), {}, Object.values(fields))

export default fields
